import React, { useState } from 'react'
import { keyFeature, aboutApp, totalLoanCost, appFeature, loanElegiblity, docRequired, applySteps, opCities, loanAgainstProperty, loanDataSecurity, appInfo, patners } from './aboutContent';
import '../textStyle.css'
import { Dialog } from "@material-ui/core";
import { Icon } from '@dashboard/common/src/component/Component';
import logo from '../../images/koshlogo.png'

const tabStyles = {
    paddingLeft: 10,
    paddingRight: 10, 
    marginTop: 10
}

const About = ({ setDialogOpen }) => {
    const [showAbout, setShowAbout] = useState(false);

    const openShowAbout = () =>{
        setDialogOpen(true)
        setShowAbout(true)
    }
    const closeShowAbout = () =>{
        setDialogOpen(false)
        setShowAbout(false)
    }
  return (
    <>
        <div className='textStyle' style={{ marginTop: 20}}>
            <div style={{ display: 'flex', width: '94%', alignItems: 'center', justifyContent: 'space-between'}}>
                <h5>About this app</h5>
                <button style={{ height: 30, width: 50, display: 'flex', fontSize: 20,  justifyContent: 'center', background: 'none', border: 'none' }} onClick={openShowAbout}>
                    <Icon className="icon ni ni-arrow-right"></Icon>
                </button>
            </div>
            <p style={{ marginTop: 5, fontSize: 14 }}>{'Instant Group Loan / Personal Loan (Rs 20,000 - Rs 2 Lakh) Low Intrest'}</p>
        </div>
        
        <Dialog open={showAbout} maxWidth='xs' fullWidth fullScreen style={{ minHeight:'100%' }} onClose={closeShowAbout}>
            <div className='textStyle' style={{ paddingRight: 15}}>
                <div style={{ height: 50, display: 'flex', alignItems: 'center', }}>
                    <button style={{ height: 30, width: 50, display: 'flex', fontSize: 20,  justifyContent: 'center', alignItems: 'center', background: 'none', border: 'none' }} 
                    onClick={closeShowAbout}>
                        <Icon className="icon ni ni-arrow-left"></Icon>       
                    </button>
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                    <img src={logo} height={40} width={40} />
                    <h4 style={{ marginLeft: 10}}>Kosh - Loan App</h4>
                </div>
                </div>
                <div style={{ height: 1, width: '100%', background: 'gray'}}></div>
                
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 15 }}>About this app</h4>
                    {
                        aboutApp.map((about, index)=>{
                            return(
                                <p style={{ margin: 5, marginBottom: index != 0 && 15}}>{about.name}</p> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 className='textStyle' style={{ marginLeft: 5, marginBottom: 15 }}>
                        Key Features
                    </h4>
                    {
                        keyFeature.map((feature, index) =>{
                            return(
                                <p key={index + 1} className='textStyle' style={{ margin: 5}}>{feature.name}</p> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 15 }}>
                        A representative example of the total cost of the loan
                    </h4>
                    {
                        totalLoanCost.map((about, index)=>{
                            return(
                                <p style={{ margin: 5}}>{about.name}</p> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Features
                    </h4>
                    {
                        appFeature.map((feature, index)=>{
                            return(
                                <div style={{ display: 'flex'}}>
                                    <span style={{ margin: 4 }}>{`${index + 1}. `}</span>
                                    <p style={{ margin: 4}}>{feature}</p>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Elegiblity
                    </h4>
                    {
                        loanElegiblity.map((feature, index)=>{
                            return(
                                <div style={{ display: 'flex'}}>
                                    <span style={{ margin: 4 }}>{`${index + 1}. `}</span>
                                    <p style={{ margin: 4}}>{feature}</p>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Documents Required
                    </h4>
                    {
                        docRequired.map((feature, index)=>{
                            return(
                                <div style={{ display: 'flex'}}>
                                    <span style={{ margin: 4 }}>{`${index + 1}. `}</span>
                                    <p style={{ margin: 4}}>{feature}</p>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        How To Apply
                    </h4>
                    {
                        applySteps.map((feature, index)=>{
                            return(
                                <div style={{ display: 'flex'}}>
                                    <span style={{ margin: 4 }}>{`${index + 1}. `}</span>
                                    <p style={{ margin: 4}}>{feature}</p>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <p style={{ margin: 4 }}>Reach us at <a href="public@getkosh.com">public@getkosh.com</a> for any of your queries. Or call at 8826790791</p>
                </div>
                <div className='textStyle' style={{ paddingLeft: 10, paddingRight: 10}}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Operational Cities
                    </h4>
                    {
                        opCities.map((feature, index)=>{
                            return(
                                <div style={{ display: 'flex'}}> 
                                    <li style={{ marginLeft: 4}}>{feature}</li>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Loan Against Property
                    </h4>
                    <p style={{ margin: 4 }}>{loanAgainstProperty}</p>
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 15 }}>
                        Loan Data Security
                    </h4>
                    {
                        loanDataSecurity.map((string, index)=>{
                            return(
                                <p style={{ margin: 5, marginTop: index != 0 && 10}}>{string}</p> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <p style={{ margin: 4 }}>Privacy Policy - <a href='https://getkosh.com/privacy-policy.html'>https://getkosh.com/privacy-policy.html</a></p>
                </div>
                <div className='textStyle' style={{ paddingLeft: 10, paddingRight: 10}}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Our Patners -
                    </h4>
                    {
                        patners.map((name, index)=>{
                            return(
                                <div style={{ display: 'flex'}}>
                                    <span style={{ margin: 4 }}>{`${index + 1}) `}</span>
                                    <p style={{ margin: 4}}>{name}</p>
                                </div> 
                            )
                        })
                    }
                </div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 5 }}>
                        Our Office Address
                    </h4>
                    <p style={{ margin: 5}}>Adhikosh Financial Advisory Pvt. Ltd.
                        #456, Sector 45, Gurgaon,
                        Haryana 122003
                    </p>
                </div>
                <div style={{ height: 1, marginTop:10, width: '100%', background: 'gray'}}></div>
                <div className='textStyle' style={tabStyles}>
                    <h4 style={{ marginLeft: 5, marginBottom: 15 }}>
                        App Info
                    </h4>
                    {
                        Object.keys(appInfo).map((key, index)=>{
                            return(
                                <div style={{ display: 'flex', width: '100%', padding: 5, marginTop: index != 0 && 5, justifyContent: 'space-between'}}>
                                    <span>{key}</span>
                                    <span>{appInfo[key]}</span>
                                </div>
                            )
                        })
                    }
                </div>

            </div>
        </Dialog>
    </>
  )
}

export default About